import Header from "../../components/common/Layouts/Header";
import Footer from "../../components/common/Layouts/Footer";
import HelmetWrapper from "../../components/common/Layouts/HelmetWrapper";
import refundPolicyContent from "../../assets/data/companyInfos/refundPolicy.json";
import "../../assets/styles/components_styles/legalDocs.css";

const BLOCK_RENDERERS = {
  updated: ({ text }, key) => (
    <p key={key} className="legalDocsUpdatedDate">
      {text}
    </p>
  ),
  heading: ({ text }, key) => (
    <h2 key={key} className="legalDocsHeading">
      {text}
    </h2>
  ),
  p: ({ text }, key) => (
    <p key={key} className="legalDocsParagraph">
      {text}
    </p>
  ),
};

const renderPolicyBlock = (block, index) => {
  const renderer = BLOCK_RENDERERS[block?.type] || BLOCK_RENDERERS.p;
  return renderer(block, `${block?.type || "p"}-${index}`);
};

export default function RefundPolicyPage() {
  const { meta = {}, blocks = [] } = refundPolicyContent;
  const pageTitle = meta.pageTitle || "Refund Policy";
  const helmetTitle = meta.helmetTitle || "Refund Policy - Pingvite";
  const helmetDescription =
    meta.helmetDescription || "Read Pingvite's refund policy for event ticket purchases.";
  const helmetKeywords = meta.helmetKeywords || "Pingvite refund policy, event refund, ticket refund";

  return (
    <>
      <HelmetWrapper
        title={helmetTitle}
        description={helmetDescription}
        keywords={helmetKeywords}
      />

      {/* HEADER */}
      <Header isHome={false} />

      {/* CONTENT */}
      <main className="legalDocsPageRoot">
        <section className="legalDocsSection">
          <div className="container">
            <div className="legalDocsContent">
              <h1 className="legalDocsTitle">{pageTitle}</h1>
              <span className="legalDocsTitleUnderline" />

              {blocks.map(renderPolicyBlock)}
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <Footer />
      </main>
    </>
  );
}
